/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Ok_ButtonInputs */

const en_ateliere_connect_ok_button = /** @type {(inputs: Ateliere_Connect_Ok_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const fr_ateliere_connect_ok_button = /** @type {(inputs: Ateliere_Connect_Ok_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const de_ateliere_connect_ok_button = /** @type {(inputs: Ateliere_Connect_Ok_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const it_ateliere_connect_ok_button = /** @type {(inputs: Ateliere_Connect_Ok_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const ru_ateliere_connect_ok_button = /** @type {(inputs: Ateliere_Connect_Ok_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ХОРОШО`)
};

const es_ateliere_connect_ok_button = /** @type {(inputs: Ateliere_Connect_Ok_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DE ACUERDO`)
};

const zh_cn2_ateliere_connect_ok_button = /** @type {(inputs: Ateliere_Connect_Ok_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`好的`)
};

const ja_ateliere_connect_ok_button = /** @type {(inputs: Ateliere_Connect_Ok_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`わかりました`)
};

const hi_ateliere_connect_ok_button = /** @type {(inputs: Ateliere_Connect_Ok_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ठीक है`)
};

const pt_pt2_ateliere_connect_ok_button = /** @type {(inputs: Ateliere_Connect_Ok_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

/**
* | output |
* | --- |
* | "OK" |
*
* @param {Ateliere_Connect_Ok_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_ok_button = /** @type {((inputs?: Ateliere_Connect_Ok_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Ok_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ateliere_connect_ok_button(inputs)
	if (locale === "de") return de_ateliere_connect_ok_button(inputs)
	if (locale === "it") return it_ateliere_connect_ok_button(inputs)
	if (locale === "ru") return ru_ateliere_connect_ok_button(inputs)
	if (locale === "es") return es_ateliere_connect_ok_button(inputs)
	if (locale === "zh-CN") return zh_cn2_ateliere_connect_ok_button(inputs)
	if (locale === "ja") return ja_ateliere_connect_ok_button(inputs)
	if (locale === "hi") return hi_ateliere_connect_ok_button(inputs)
	if (locale === "pt-PT") return pt_pt2_ateliere_connect_ok_button(inputs)
	return en_ateliere_connect_ok_button(inputs)
});